interface Lesson {
  id: number;
  title: string;
}

interface LessonsListProps {
  lessons: Lesson[];
  selectedLesson: number | null;
  onLessonSelect: (id: number) => void;
  onShowSummary: () => void;
  onShowChecklist: () => void;
  onShowAssessment: () => void;
}

function LessonsList({ 
  lessons, 
  selectedLesson, 
  onLessonSelect,
  onShowSummary,
  onShowChecklist,
  onShowAssessment
}: LessonsListProps) {
  return (
    <div className="bg-white rounded-xl border border-gray-200 p-6">
      <h3 className="text-lg font-bold text-[#1A3A2E] mb-4 flex items-center gap-2">
        <i className="ri-list-check text-[#39FF14]"></i>
        Contenido del Módulo
      </h3>

      <div className="space-y-2 mb-6">
        {lessons.map((lesson) => (
          <button
            key={lesson.id}
            onClick={() => onLessonSelect(lesson.id)}
            className={`w-full text-left px-4 py-3 rounded-lg transition-all cursor-pointer ${
              selectedLesson === lesson.id
                ? 'bg-[#39FF14] text-[#1A3A2E] font-semibold'
                : 'bg-gray-50 text-gray-700 hover:bg-gray-100'
            }`}
          >
            <div className="flex items-start gap-3">
              <span className="text-sm font-bold mt-0.5">
                {lesson.id}.
              </span>
              <span className="text-sm flex-1">{lesson.title}</span>
            </div>
          </button>
        ))}
      </div>

      <div className="border-t border-gray-200 pt-4 space-y-2">
        <button
          onClick={onShowSummary}
          className="w-full text-left px-4 py-3 rounded-lg bg-gradient-to-r from-[#1A3A2E] to-[#0F2419] text-white hover:opacity-90 transition-opacity cursor-pointer"
        >
          <div className="flex items-center gap-3">
            <i className="ri-file-text-line text-[#39FF14]"></i>
            <span className="text-sm font-semibold">Resumen Ejecutivo</span>
          </div>
        </button>

        <button
          onClick={onShowChecklist}
          className="w-full text-left px-4 py-3 rounded-lg bg-gray-50 text-gray-700 hover:bg-gray-100 transition-colors cursor-pointer"
        >
          <div className="flex items-center gap-3">
            <i className="ri-checkbox-line text-[#39FF14]"></i>
            <span className="text-sm font-semibold">Checklist Práctico</span>
          </div>
        </button>

        <button
          onClick={onShowAssessment}
          className="w-full text-left px-4 py-3 rounded-lg bg-gray-50 text-gray-700 hover:bg-gray-100 transition-colors cursor-pointer"
        >
          <div className="flex items-center gap-3">
            <i className="ri-quiz-line text-[#39FF14]"></i>
            <span className="text-sm font-semibold">Autoevaluación</span>
          </div>
        </button>
      </div>
    </div>
  );
}

export default LessonsList;